<router-outlet></router-outlet>
<app-overlay-loader *ngIf="showLoader"></app-overlay-loader>
